module.exports = "img/warning2.0a978e0.png";